module.exports = __webpack_public_path__ + "static/media/Gujarat_Technological_University_Logo.dea65318.png";